"use client";

import { useEffect, useRef } from "react";

import { ADS_CLIENT } from "@/components/ads/config";
import styles from "./BaseArticle.module.css";
import { useNearViewportAd } from "@/components/ads/useNearViewportAd";

declare global {
  interface Window { adsbygoogle?: unknown[]; }
}

/** Exactly one AdSense Base Inline unit; no auto-ads or legacy GAM slots. */
export default function BaseArticleInlineAd() {
  const { containerRef, ready } = useNearViewportAd(Boolean(ADS_CLIENT));
  const adRef = useRef<HTMLModElement>(null);
  const pushedRef = useRef(false);

  useEffect(() => {
    if (!ready || !adRef.current || pushedRef.current) return;
    if (adRef.current.getAttribute("data-adsbygoogle-status")) return;
    try {
      (window.adsbygoogle = window.adsbygoogle || []).push({});
      pushedRef.current = true;
    } catch (error) {
      console.warn("AdSense Base Inline initialization failed:", error);
    }
  }, [ready]);

  return (
    <div ref={containerRef} className={styles.inlineAdWrap} style={{ marginTop: 20, marginBottom: 36 }} aria-label="Advertisement">
      <div className={styles.inlineAdInner}>
        <div style={{ textAlign: "center", fontSize: 11, letterSpacing: "0.14em", opacity: 0.65, marginBottom: 12 }}>
          ADVERTISEMENT
        </div>
        {ready ? <ins
          ref={adRef}
          className="adsbygoogle"
          style={{ display: "block" }}
          data-ad-client="ca-pub-7902170378611353"
          data-ad-slot="8889662894"
          data-ad-format="auto"
          data-full-width-responsive="true"
        /> : null}
      </div>
    </div>
  );
}

